import { useQuery } from "@tanstack/react-query";
import { TableCard } from "ui-components/Layout";
import { ListLayout } from "ui-components/Layout";
import BasicTable from "ui-components/tables/BasicTable";
import { StockAttributesColumns } from "./columns";
import { useState } from "react";
import { useCustomerValue } from "providers/CustomerContext";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { getStockAttributesEnquiry } from "services/data.report.service";
import { CSVLink } from "react-csv";
import { useTeamValue } from "providers/TeamContext";
import dayjs from "dayjs";
import { CustomDateRangePicker } from "ui-components/CustomInput";
import { Grid } from "@mui/material";
import { LoadingDialog } from "ui-components/Alert";
import { ExportDialog } from "ui-components/Alert";
import useCsvDownloadHook from "hooks/useCsvDownloadHook";

function StockAttributesEnquiry() {
  const { permissions, allowAll } = useTeamValue();
  const { customerCode } = useCustomerValue();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const exportPermission = allowAll || (Boolean(permissions["Stock Attributes_Report"]) && permissions["Stock Attributes_Report"].findIndex(b => b === "export") !== -1);
  const date = dayjs(new Date()).format("YYYY-MM-DD");
  const sevenDaysBefore = dayjs(new Date()).subtract(1, 'day').format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(sevenDaysBefore);
  const [endDate, setEndDate] = useState(date);
  const customProps = { startDate, setStartDate, endDate, setEndDate };
  const [alert, setAlert] = useState(null);
  const { downloadCsv, isDownloading } = useCsvDownloadHook();
  const onFetch = () => {
    setAlert(null);
    const valid =
      dayjs(endDate).isSame(dayjs(startDate)) ||
      dayjs(endDate).isAfter(dayjs(startDate));
    if (!valid) {
      setAlert(<Error_ content="Start date cannot greater than end date" onChange={setAlert} />);
      return;
    }
    if (dayjs(date).isBefore(endDate)) {
      setAlert(<Error_ content="End date cannot greater than today date" onChange={setAlert} />);
      return;
    }
    refetch();
  };
  const handleFilterRowsChange = (filteredData) => {
    setFilteredData(filteredData);
  };

  const { refetch, isFetching } = useQuery({
    queryKey: ["stock-attributes-enquiry", { customerCode }],
    queryFn: () => getStockAttributesEnquiry({ customerCode, startDate, endDate }),
    enabled: Boolean(customerCode),
    onSuccess: (data) => {
      setData(data.data.data);
      setFilteredData(data.data.data);
    },
    onError: () => { },
  });
  return (
    <ListLayout>
      {isFetching && <LoadingDialog />}
      {isDownloading && <ExportDialog />}
      {alert && <MDBox sx={{ my: 3 }}>{alert}</MDBox>}
      <TableCard sx={{ my: 3 }}>
        <MDBox margin="1rem 0 0 1rem">
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <CustomDateRangePicker {...customProps} />
            </Grid>
            <Grid item xs={4}>
              <MDButton
                variant="gradient"
                color="info"
                onClick={() => {
                  onFetch();
                }}
              >
                search
              </MDButton>
              {/* <MDButton sx={{ marginLeft: "1rem" }} variant="gradient" color="info" disabled={!exportPermission}>
                <CSVLink style={{ color: "white" }} filename={`StockAttributes_`} data={filteredData}>
                  export
                </CSVLink>
              </MDButton> */}
              <MDButton
                sx={{ marginLeft: "1rem" }} variant="gradient" color="info" disabled={!exportPermission}
                onClick={() => {
                  const filename = `${customerCode}_${dayjs(new Date()).format("YYYYMMDD-HHmm")}_StockAttributes`;
                  downloadCsv(filename, filteredData)
                }}
              >
                export
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>
        {/* <MDBox display="flex" justifyContent="flex-end" margin="10px">
          <MDButton variant="gradient" color="info" disabled={!exportPermission}>
            <CSVLink style={{ color: "white" }} filename={`Transfer_`} data={filteredData}>
              export
            </CSVLink>
          </MDButton>
        </MDBox> */}
        <BasicTable data={data} columns={StockAttributesColumns} onFilterRowsChange={handleFilterRowsChange} />
      </TableCard>
    </ListLayout>
  );
}

export default StockAttributesEnquiry;
